<h2 mat-dialog-title>Stai per eliminare {{data.value}}</h2>
<mat-dialog-content class="mat-typography">
  <p>Sei sicuro di voler continuare?</p>
</mat-dialog-content>
<mat-dialog-actions >
  <button mcButton variant="closedialog" mat-dialog-close>Chiudi</button>
  <button mcButton variant="confirmdialog" [mat-dialog-close]="true" cdkFocusInitial>Elimina</button>
</mat-dialog-actions>
